import { NoProductsFound } from '@teko/ecommerce';
import { styled } from '@teko/ui';
import React from 'react';
import { DiscoveryBlocks } from 'components/desktop/organisms';
import { useIdentifiedPage } from 'hooks';
import { BlockPageProps } from '../shared';
import { DiscoveryBlock } from '@teko/discovery';

const NoProductsFoundStyled = styled(NoProductsFound)`
  margin-top: 0 !important;
  padding-top: 10rem;
  width: 100%;
  min-height: 80vh;
  background-color: white;
`;

const Wrapper = styled.div`
  min-height: 80vh;
`;

export const BlockPageContent: React.FC<BlockPageProps> = ({
  loadingBlocks,
  blocks,
  excludeBlockType,
  cookedFilters,
  filterPrice,
  mapSSRProducts,
  filters,
}: BlockPageProps) => {
  useIdentifiedPage('category');

  if (!loadingBlocks && (!blocks || blocks.length === 0)) {
    return <NoProductsFoundStyled show={true} />;
  }

  return (
    <Wrapper>
      <DiscoveryBlocks
        blocks={blocks.filter(
          (block: DiscoveryBlock) => !excludeBlockType.includes(block.type),
        )}
        ssrMapProducts={mapSSRProducts}
        cookedFilters={cookedFilters}
        filterPrice={filterPrice}
        filters={filters}
      />
    </Wrapper>
  );
};
